import { ManagerSales } from '@sorare/marketplace/src/components/market/ManagerSales';

import { SelectedLeaderboardBanner } from '#src/components/searchCards/SelectedLeaderboardBanner/index.tsx';

const ManagerSalesPage = () => {
  return <ManagerSales banner={<SelectedLeaderboardBanner />} />;
};

export default ManagerSalesPage;
